const useJobIcon = (jobType) => {
    switch (jobType) {
    case 'student_job': return 'student-job'
    case 'internship': return 'internship'
    case 'first_job': return 'first-job'
    case 'education': return 'choice'
    case 'company': return 'building'
    case 'kot': return 'kot'
    case 'article': return 'speak'
    }
}

export default useJobIcon
